'use strict';

angular.module('sellEnquiryController', [])

.controller('SellEnquiryController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window','AgencyService', 'BuyerService', 'CommonService', 
    function (appInfo, $scope, $rootScope, $log, $location, $window, AgencyService, BuyerService, CommonService) {    
    
      var activeAgency = $rootScope.currentUser.activeAgency;
      $scope.page = 'sellEnquiry';
      var currentUser = $rootScope.currentUser;
      $scope.sellEnquiry = {
        name: currentUser.name,
        email: currentUser.info.email,
        phone: currentUser.info.mobile,
      };

      $scope.sendSellEnquiry = function() {
        if($scope.sellEnquiry.name == '' || $scope.sellEnquiry.email =='' || $scope.sellEnquiry.phone == '') {
          alert('Name, Email and Phone are mandatory fields.');
          return;
        } else {
          $rootScope.loading = true;

          BuyerService.sendSellEnquiry($scope.sellEnquiry)
          .then(function(data){
              alert('Your enquiry has been sent to ' + activeAgency.organisation);
          })
          .catch(function(err){
              console.log(err);
          })
          .finally(function(data){
              $rootScope.loading = false;
          });
        }
        
      }

}]);